import React from 'react';
import { Link } from 'react-router-dom';

const base =
  'inline-flex items-center justify-center gap-2 rounded-btn px-5 py-2.5 text-sm font-medium transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20 disabled:opacity-50 disabled:cursor-not-allowed';

const variants = {
  primary: 'bg-body text-bg hover:bg-white',
  secondary:
    'border border-white/12 text-body bg-transparent hover:bg-white/[.04] hover:border-white/20',
  ghost: 'text-muted hover:text-body hover:bg-white/[.04]',
};

const Button = ({ variant = 'primary', to, href, className = '', children, ...rest }) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
};

export default Button;
